import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import { returnFromSupplierSchema } from '@/schemas/returnFromSupplier'
import { nextTick, onMounted, ref } from 'vue'
import { getBatchById } from '@/api/batches'
import { useToast } from 'primevue/usetoast'
import { useRouter } from 'vue-router'

export const useReturnFromSupplierForm = (): any => {
  const { values, handleSubmit, errors, setErrors, resetForm, setFieldValue, meta } = useForm({
    validationSchema: toTypedSchema(returnFromSupplierSchema),
  });
  const toast = useToast();
  const loading = ref(false);
  const router = useRouter();

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000,
    });
  };

  onMounted(async () => {
    loading.value = true;
    const batchId = router.currentRoute.value.params.id as string;
    try {
      const batch: any = await getBatchById(batchId);

      if (batch) {
        resetForm({
          values: { ...batch },
        });

        await nextTick();
      }
    } catch (error) {
      showToast('error', 'Error', 'Failed to fetch batch data.');
    } finally {
      loading.value = false;
    }
  });

  return {
    values,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    setFieldValue,
    meta,
    showToast,
    loading,
  };
};